// extracted by mini-css-extract-plugin
export var divider = "_dp-7";
export var itemsToggle = "_dp-8";
export var mergeModal = "_dp-1";
export var optionCard = "_dp-4";
export var radioGroup = "_dp-6";
export var radioOption = "_dp-0";
export var selected = "_dp-5";
export var shipmentOptions = "_dp-2";
export var tableOptions = "_dp-3";